import { ComponentType } from 'react';

export const compareComponents = <T extends ComponentType>(comp: any, target: T): comp is T => {
  if (comp.$$typeof === Symbol.for('react.memo')) {
    return comp.type === target;
  }

  return comp === target;
};
